import { gql, TypedDocumentNode } from "@apollo/client";

import { AiIntegration, MutationAiIntegrationCreateArgs } from "types/generated";

export const CREATE_AI_INTEGRATION: TypedDocumentNode<
  {
    aiIntegrationCreate: Pick<AiIntegration, "id">;
  },
  MutationAiIntegrationCreateArgs
> = gql`
  mutation CreateAiIntegration(
    $name: String!
    $description: String
    $labels: [String!]!
    $provider: String!
    $apiKey: String
    $providerIntegrationId: ID
    $providerConfig: AIProviderConfigInput
    $baseURL: String
    $models: [String!]
    $space: ID
  ) {
    aiIntegrationCreate(
      name: $name
      description: $description
      labels: $labels
      provider: $provider
      apiKey: $apiKey
      providerIntegrationId: $providerIntegrationId
      providerConfig: $providerConfig
      baseURL: $baseURL
      models: $models
      space: $space
    ) {
      id
    }
  }
`;
